import { render, staticRenderFns } from "./error.vue?vue&type=template&id=fc2ae786&scoped=true&"
import script from "./error.vue?vue&type=script&lang=js&"
export * from "./error.vue?vue&type=script&lang=js&"
import style0 from "./error.vue?vue&type=style&index=0&id=fc2ae786&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.10.1_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@4.3.0_lodash@4.17._ziirscntm6ri7or2susu3mlgei/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2ae786",
  null
  
)

export default component.exports